export default {
  colors: {
    primary: '#00cc73',
    primary_light: 'rgba(20, 179, 92, 0.2)',
    header: '#00cc73',
    success: '#00cc73',
    attention: '#E83F5B',
    hot_background_opacity: '#E83F5B',
    hot_background_border: '#E83F5B',
    promo_marquee_bg: ['#811F10', '#B12722', '#811F10'],
    shape: '#fff',
    tab: '#fff',
    tabSpotlightMenu: '#00cc73',
    tabSpotlightMenuText: '#FFFFFF',
    buttonTitle: '#FFFFFF',
    mask: 'rgba(0,0,0, 0.68)',
    mask_station: 'rgba(0,0,0, 0.68)',
    mask_coupon: 'rgba(0,0,0, 0.9)',
    title: '#222',
    text: '#767676',
    text_fixed: '#767676',
    brbButton: '#173C78',
    text_2: '#797e91',
    tabInactive: '#686c7d',
    text_dark: '#2A2A2A',
    border_tab: '#CCC',
    border: '#e0dfdf',
    border_light: '#e0dfdf',
    border2: '#f2eded',
    border3: '#f8f8f8',
    border_opacity: 'rgba(0,0,0, 0.1)',
    image_border: '#f0f0f0',
    placeholder: '#aaa',
    background: '#fff',
    background_secondary: '#F8F8F8',
    button_click_bg: 'rgba(0,0,0,0.1)',
    background_black: '#F8F8F8',
    background_black_2: '#e8e8e8',
    price_card: '#F8F8F8',
    input_search: '#F8F8F8',
    alert: '#f8f8f8',
    silver: '#C6C6C6',
    buttonFeedback: '#AAA',
    gold_gradient: ['#ECB451', '#FCCC61', '#ECB451'],
    gold: '#FFD064',
    gold_light: '#ffe096',
    silver_gradient: ['#A2A2A2', '#BCBCBC', '#A2A2A2'],
    blue_gradient: ['#158CBE', '#0C6388', '#158CBE'],
    silver_dark: '#9A9A9A',
    silver_text: '#FFFFFF',
    gold_dark: '#E8AE4D',
    gold_text: '#FFFFFF',
    blue: '#10AECA',
    blue_main_opacity: '#E9FCFF',
    blue_opacity: 'rgba(21,140,190, 0.1)',
    red: '#FE7879',
    yellow: '#FDBB61',
    orange: '#ff9514',
    orange_dark: '#ff7002',
    orange_opacity: 'rgba(255, 149, 20, 0.35)',
    purple: '#CDA1FB',
    pink: '#FB9EC1',
    blue_light: '#92CBF7',
    blue_ocean: '#72B4B9',
    red_light: '#E1A09A',
    green_light: '#E2F1DA',
    promotion_value_bg: '#E2F1DA',
    black: '#2A2A2A',
    banner_blue: '#83D9F4',
    banner_blue_shadow: '#39B1DA',
    banner_red: '#F57791',
    banner_red_shadow: '#FA3852',
    banner_purple: '#A5B6FD',
    banner_purple_shadow: '#718BD8',
    banner_green: '#66D977',
    banner_green_shadow: '#54B362',
    clube_gradient: ['#d8f0cc', '#fff'],
    purple_2_shadow_white: '#F9F2FA',
    purple_2_gradient: ['#ff9514', '#ff8c00', '#FF6B00'],
    purple_2_border: '#FFC379',
    spin_button_backgrund: '#BF3DFF',
    spins_text_background: ['#FBB54F', '#FECF76', '#A35A15'],
    spins_text_border: '#FBB54F',
    spin_button_gradient: ['#c962fc', '#BF3DFF', '#9d09e6'],
    fine_alert_gradient: ['#136C4C', '#0d4b34ff'],
    shimmer_placeholder: ['#e6e4e6', '#c6c6c6', '#e6e4e6'],
    loading: '#FFF',
    red_gradient: ['#B00000', '#FF3B3B', '#B00000'],

    newCouponScreenRed: '#A94343',
    newCuponScreenRedLight: '#F9EBEB',
    newCouponScreenGreen: '#19966A',
    newCuponScreenGreenLight: '#EBF9EF',
    newCuponScreenBackground: '#FFFFFF',
    newCuponScreenBackgroundSecondary: '#F2F2F2',

    /* ─── Empréstimo / Loan ─── */
loan_banner_bg: '#158CBE',
    loan_banner_text: '#FFFFFF',
    loan_banner_text_secondary: 'rgba(255, 255, 255, 0.85)',
    loan_banner_overlay: 'rgba(255, 255, 255, 0.2)',
    loan_action_text: '#158CBE',
    loan_otp_icon_bg: 'rgba(21, 140, 190, 0.1)',
    loan_otp_icon: '#158CBE',
    alert_red_bg: '#FEF2F2',
    alert_red_border: '#FECACA',
    alert_red_icon: '#EF4444',
    alert_red_title: '#DC2626',
    alert_orange_bg: '#FFF7ED',
    alert_orange_border: '#FED7AA',
    alert_orange_icon: '#F97316',
    alert_orange_title: '#EA580C',
    alert_blue_bg: '#EFF6FF',
    alert_blue_border: '#BFDBFE',
    alert_blue_icon: '#3B82F6',
    alert_blue_title: '#1D4ED8',
    alert_green_bg: '#F0FDF4',
    alert_green_border: '#BBF7D0',
    alert_green_icon: '#22C55E',
    alert_green_title: '#16A34A',
    success_bg: '#E3F3DE',
    error_bg: '#D98E92',
    error_icon: '#B84B4B',
    attention_opacity: 'rgba(232, 63, 91, 0.12)',
    gold_opacity: 'rgba(253, 187, 97, 0.18)',


    /* ─── Home services grid ─── */
    home_service_fuel_bg: '#E6FBF1',
    home_service_fuel_icon_bg: '#04D186',
    home_service_fines_bg: '#F1F2F7',
    home_service_fines_icon_bg: '#2A2A2A',
    home_service_loan_bg: '#FFF7D6',
    home_service_loan_icon_bg: '#FFBE18',
    home_service_others_bg: '#E1EEFB',
    home_service_others_icon_bg: '#1063A6',
  },

  fonts: {
    light: 'Poppins-Light',
    regular: 'Poppins-Regular',
    medium: 'Poppins-Medium',
    semibold: 'Poppins-SemiBold',
    bold: 'Poppins-Bold',
    fuel: 'OpenSans-ExtraBoldItalic',
  },

  mapstyle: [
    {
      featureType: 'administrative',
      elementType: 'all',
      stylers: [
        {
          visibility: 'on',
        },
      ],
    },
    {
      featureType: 'administrative',
      elementType: 'geometry.fill',
      stylers: [
        {
          visibility: 'on',
        },
      ],
    },
    {
      featureType: 'administrative',
      elementType: 'geometry.stroke',
      stylers: [
        {
          visibility: 'on',
        },
      ],
    },
    {
      featureType: 'administrative',
      elementType: 'labels.text',
      stylers: [
        {
          visibility: 'on',
        },
      ],
    },
    {
      featureType: 'landscape',
      elementType: 'all',
      stylers: [
        {
          visibility: 'on',
        },
      ],
    },
    {
      featureType: 'poi',
      elementType: 'all',
      stylers: [
        {
          visibility: 'on',
        },
      ],
    },
    {
      featureType: 'road',
      elementType: 'all',
      stylers: [
        {
          visibility: 'on',
        },
      ],
    },
    {
      featureType: 'transit',
      elementType: 'all',
      stylers: [
        {
          visibility: 'on',
        },
      ],
    },
    {
      featureType: 'water',
      elementType: 'all',
      stylers: [
        {
          visibility: 'on',
        },
      ],
    },
  ],
};
